import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { SEDES_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'

export default function CompaniasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${SEDES_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
